import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * O legado tinha UMA tela para os dois quadros (QuadroHorarioTurma.aspx?modoExecucao=0|1). Aqui
 * são duas rotas, uma por permissão — as mesmas que já existiam no menu.
 */
export default [
  {
    description: 'Quadro de horários da turma',
    path: '/academico/quadrohorario/turma',
    name: 'quadroHorarioTurma',
    component: () => import('@/views/academico/quadrohorario/turma/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.QUADRODATURMA_MENU_301000701],
    },
    goesToMenu: true,
  },
  {
    description: 'Quadro de horários do professor',
    path: '/academico/quadrohorario/professor',
    name: 'quadroHorarioProfessor',
    component: () => import('@/views/academico/quadrohorario/professor/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.QUADRODOPROFESSOR_MENU_301000801],
    },
    goesToMenu: true,
  },
];
